import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import logo from '../img/upton.png'

class Nav extends Component {
  render () {
    return (

      <div className='flex flex-row items-center justify-center lg:justify-between w-full h-24'>
        <Link className='flex flow-row items-center justify-between' to='/'>
          <img className='logo contain w-32 mr-8' src={logo} alt='Makers Logo' />
          <h1 className='text-upton-100 text-2xl'>Upton Priory School</h1>
        </Link>
      </div>

    )
  }
}

const mapStateToProps = () => ({ })

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Nav)
)
